import axiosClient from "../../shared/components/requests/axiosCLient";
import { API_URLS } from "../../shared/constants/constants";

export const getEventsAndCampaign = () => {
  const url = API_URLS.eventsAndCampaign;
  return axiosClient.get(url);
};
export const getEventsAndCampaignList = () => {
  const url = API_URLS.eventsAndCampaignList;
  return axiosClient.get(url);
};
export const getBannerDetails = (id) => {
  const url = API_URLS.eventBannerDetails(id);
  return axiosClient.get(url);
};
export const getCampaignDetails = (id) => {
  const url = API_URLS.eventCampaignDetails(id);
  return axiosClient.get(url);
};
